<template>
  <div class="main_bg" style="background-image: url('img/noble/main_bg.png')">
    <nav-barr
      class="title_top"
      :icon="'img/backw.png'"
      :textColor="'rgba(255, 214, 158, 1)'"
      :backColor="'transparent'"
    />
    <div
      class="svga_box"
      :style="'background-image:url(' + bgList[index] + ')'"
    >
      <div class="juewei">
        <div v-show="current == 0" style="width: 100%; height: 100%">
          <SvgaDisplay
            ref="svgaPlayer"
            :src="svgaSrc1"
            :width="250"
            :height="250"
            :autoplay="true"
          />
        </div>
        <div v-show="current == 1" style="width: 100%; height: 100%">
          <SvgaDisplay
            ref="svgaPlayer"
            :src="svgaSrc2"
            :width="250"
            :height="250"
            :autoplay="true"
          />
        </div>
        <div v-show="current == 2" style="width: 100%; height: 100%">
          <SvgaDisplay
            ref="svgaPlayer"
            :src="svgaSrc3"
            :width="250"
            :height="250"
            :autoplay="true"
          />
        </div>
      </div>
    </div>

    <van-tabs
      @click="tabClick"
      v-model="active"
      swipeable
      background="transparent"
      title-active-color="#FFD69E"
      color="#FFD69E"
      title-inactive-color="rgba(255, 214, 158, .6)"
    >
      <van-tab
        v-for="(item, index) in nobleList"
        :title="item.noble_name"
        :key="index"
      ></van-tab>
    </van-tabs>
    <div class="title">
      <img v-if="index == 0" src="img/noble/xinxiu.png" alt="" /><img
        v-if="index == 1"
        src="img/noble/qishi.png"
        alt=""
      /><img v-if="index == 2" src="img/noble/shenwang.png" alt="" />
    </div>
    <div
      class="list_box"
      style="background-image: url('img/noble/list_bg.png')"
    >
      <div class="top">
        <img class="icon" src="img/noble/01.png" alt="" />
        <img class="icon" src="img/noble/02.png" alt="" />
        <img class="icon" src="img/noble/03.png" alt="" />
        <img class="icon" src="img/noble/04.png" alt="" />
      </div>
      <div class="mid">
        <img class="icon" src="img/noble/05.png" alt="" />
        <img class="icon" src="img/noble/06.png" alt="" />
        <img class="icon" src="img/noble/07.png" alt="" />
        <img
          v-if="index == 1 || index == 2"
          class="icon"
          src="img/noble/09.png"
          alt=""
        />

        <!-- <img class="icon" src="img/noble/08.png" alt="" /> -->
      </div>
      <div class="mid">
        <img class="icon" src="img/noble/10.png" alt="" />
        <!-- <img v-if="index > 0" class="icon" src="img/noble/11.png" alt="" /> -->
        <!-- <img v-if="index > 1" class="icon" src="img/noble/12.png" alt="" /> -->
        <!-- <img class="icon" src="img/noble/13.png" alt="" /> -->
        <img class="icon" src="img/noble/14.png" alt="" />
      </div>
      <div class="bot" v-if="index > 1"></div>
    </div>
    <div
      class="open"
      style="background-image: url('img/noble/open.png')"
      v-if="isShowOpen"
    >
      <div class="value">
        <div style="display: flex; align-items: center">
          {{
            nobleList[index].is_open == 0
              ? "首开" + nobleList[index].noble_name + "："
              : "续费" + nobleList[index].noble_name + "："
          }}
          <img class="bi" src="img/bi.png" alt="" />
          <span>{{
            nobleList[index].is_open == 0
              ? nobleList[index].diamonds + "/月"
              : nobleList[index].renew_diamonds + "/月"
          }}</span>

          <span style="margin-left: 5px"
            >赠送{{
              nobleList[index].is_open == 0
                ? nobleList[index].send_diamonds
                : nobleList[index].renew_send_diamonds
            }}</span
          >
          <img class="bi" src="img/bi.png" alt="" />
          <!-- <span
                 style="margin-left: 5px;"
            >赠送{{
              nobleList[index].is_open == 0
                ? nobleList[index].send_diamonds
                : nobleList[index].renew_send_diamonds
            }}</span
          >
          <img class="bi" src="img/sliver.png" alt="" /> -->
        </div>

        <div
          v-if="nobleList[index].is_open == 1"
          class="expire_time"
          style="margin-top: 5px"
        >
          {{ "到期时间：" + nobleList[index].expire_at }}
        </div>
      </div>
      <div>
        <div
          class="open_btn"
          @click="showConfirm"
          v-if="nobleList[index].is_open == 0"
          style="background-image: url('img/noble/open_btn.png')"
        ></div>
        <div
          class="open_btn"
          @click="showConfirm"
          v-if="nobleList[index].is_open == 1 && showBtn"
          style="background-image: url('img/noble/renew_btn.png')"
        ></div>
        <div style="display: flex; align-items: center; margin-top: 5px">
          <input type="checkbox" v-model="check" /><span class="noble_tips_"
            >我已阅读并同意</span
          ><span class="noble_tips" @click="toAgreement"
            >《贵族与付费订阅服务协议》</span
          >
        </div>
      </div>
    </div>
    <div class="pay_info" v-if="isShowConfirm">
      <div class="bottom_title">
        {{ nobleList[index].is_open == 0 ? "开通贵族" : "续费贵族" }}
        <div
          class="close"
          style="background-image: url('img/noble/close.png')"
          @click="isShowConfirm = false"
        ></div>
      </div>
      <div
        class="info_bg"
        style="background-image: url('img/noble/info_bg.png')"
      >
        <img
          v-if="index == 0"
          class="noble_item"
          src="https://fwapk.oss-cn-hangzhou.aliyuncs.com/duole/g1.png"
          alt=""
        />
        <img
          v-if="index == 1"
          class="noble_item"
          src="https://fwapk.oss-cn-hangzhou.aliyuncs.com/duole/g2.png"
          alt=""
        />
        <img
          v-if="index == 2"
          class="noble_item"
          src="https://fwapk.oss-cn-hangzhou.aliyuncs.com/duole/g3.png"
          alt=""
        />
        <div class="info">
          {{ "贵族*" + nobleList[index].noble_name }}
          <img class="month_icon" src="img/noble/icon.png" alt="" />
        </div>
      </div>
      <div class="pay_btn" @click="openNob" v-if="!clicked">
        {{ nobleList[index].is_open == 0 ? "立即开通" : "立即续费" }}
      </div>
    </div>
  </div>
</template>
<script>
import "@/assets/css/index.css";
import { nobleList, openNoble } from "@/api/api";
import SvgaDisplay from "@/components/SvgaDisplay.vue";
import NavBarr from "@/components/navBarr.vue";
export default {
  components: {
    NavBarr,
    SvgaDisplay,
  },
  data() {
    return {
      active: 0,
      index: 0,
      current: 0,
      svgaSrc1: "https://fwapk.oss-cn-hangzhou.aliyuncs.com/duole/g1.svga",
      svgaSrc2: "https://fwapk.oss-cn-hangzhou.aliyuncs.com/duole/g2.svga",
      svgaSrc3: "https://fwapk.oss-cn-hangzhou.aliyuncs.com/duole/g3.svga",
      nobleList: [],
      bgList: ["img/noble/xx.png", "img/noble/qs.png", "img/noble/sw.png"],
      isShowConfirm: false,
      isShowOpen: true,
      clicked: false,
      check: false,
      sevenDays: 604800,
      showBtn: false,
    };
  },
  created() {
    let access_token = this.$route.query.access_token;
    localStorage.setItem("access_token", access_token);
    this.getNobleList();
  },
  methods: {
    tabClick(index, title) {
      this.index = index;
      this.current = index;
    },
    getNobleList() {
      nobleList({}).then((res) => {
        console.log(res);
        this.nobleList = res.data.data;
        for (let i in this.nobleList) {
          if (this.nobleList[i].is_open == 1) {
            let expire_at =
              new Date(this.nobleList[i].expire_at).getTime() / 1000;
            let now = new Date().getTime() / 1000;
            if (expire_at - now < this.sevenDays) {
              this.showBtn = true;
            } else {
              this.showBtn = false;
            }
          }
        }
        this.level = res.data.noble_level;
      });
    },
    showConfirm() {
      if (!this.check) {
        this.$toast.fail("请阅读并同意协议");
        return false;
      }
      this.isShowConfirm = true;
    },
    toAgreement() {
      this.$router.push({ path: "/nobleAgreement" });
    },
    openNob() {
      let params = {
        noble_id: this.nobleList[this.index].id,
      };
      openNoble(params)
        .then(
          (res) => {
            this.$toast.success(
              this.nobleList[this.index].is_open == 0 ? "开通成功" : "续费成功"
            );
            this.isShowConfirm = false;
            this.clicked = true;
            this.isShowOpen = false;
            this.getNobleList();
          },
          (error) => {
            this.$toast.fail(error);
          }
        )
        .catch((error) => {
          this.$toast.fail(error);
        });
    },
  },
};
</script>
<style scoped>
.title {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.svga_box {
  width: 708px;
  height: 262px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin: 52px auto 0;
  display: flex;
  justify-content: flex-end;
}
.main_bg {
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
  overflow-x: hidden;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-bottom: 200px;
  padding-top: 0.8rem;
  background-color: #11121c;
}
.juewei {
  width: 250px;
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 50px;
}

.noble_tips {
  color: #fff;
  font-size: 18px;
  text-decoration: underline;
}
.noble_tips_ {
  color: #fff;
  font-size: 18px;
}
.list_box {
  width: 708px;
  height: 804px;
  margin: 34px auto 0;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
}
.icon {
  width: 110px;
  height: 131px;
  overflow: hidden;
}
.exp {
  width: 72px;
  height: 28px;
  display: block;
  margin: 30px auto 0;
}
.level_up {
  font-size: 24px;
  color: #efccb2;
  text-align: center;
  margin-top: 42px;
}
.level_info {
  font-size: 20px;
  color: #50423b;
  text-align: center;
  margin-top: 8px;
}
.top {
  display: flex;
  width: 660px;
  height: 131px;
  margin: 56px auto 0;
}
.mid {
  display: flex;
  width: 660px;
  height: 131px;
  margin: 56px auto 0;
}
.bot {
  display: flex;
  width: 660px;
  height: 131px;
  margin: 56px auto 0;
}
.icon {
  margin-left: 7%;
}
.open {
  width: 100vw;
  height: 240px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.open_btn {
  width: 340px;
  height: 88px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-top: 10px;
}
.value {
  font-size: 22px;
  color: #f8d1a3;
  margin-top: 10px;
}
.bi {
  width: 30px;
  height: 34px;
}
.pay_info {
  width: 100vw;
  height: 640px;
  background-color: #15151d;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  position: fixed;
  bottom: 0;
  left: 0;
}
.info_bg {
  width: 702px;
  height: 255px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin: 40px auto 0;
  display: flex;
  align-items: center;
}
.bottom_title {
  font-size: 30px;
  text-align: center;
  color: #ffd69e;
  margin-top: 40px;
  position: relative;
}
.close {
  position: absolute;
  width: 50px;
  height: 50px;
  top: -50px;
  right: 5px;
  display: block;
  z-index: 99999;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.info {
  display: flex;
  align-items: center;
  font-size: 30px;
  color: #ffd69e;
}
.noble_item {
  width: 183px;
  height: 183px;
}
.month_icon {
  width: 72px;
  height: 35px;
  margin-left: 20px;
}
.pay_btn {
  width: 702px;
  height: 88px;
  background-color: #fae4bd;
  text-align: center;
  font-size: 30px;
  color: #67310f;
  text-align: center;
  line-height: 88px;
  border-radius: 44px;
  margin: 106px auto 0;
}
</style>